<script lang="ts">
  import { _ } from "svelte-i18n";
  import HowVisual from "./how/HowVisual.svelte";
</script>

<div id="edittestpublish" class="section bg-black py-8">
  <div class="container">
    <div class="row justify-content-between align-items-center mb-3">
      <div class="col-12 col-md-7 order-md-1">
        <span class="badge rounded-pill bg-light text-bg-light mb-2">
          <span class="h6 text-uppercase">{$_("home.edittestpublish.tag")}</span
          >
        </span>
        <h2 class="text-white" style="max-width: 450px;">
          {$_("home.edittestpublish.title")}
        </h2>
      </div>
    </div>
    <div class="row">
      <HowVisual />
    </div>
  </div>
</div>
